<template>
    <div id="updatePoints" class="col-12 p-0">
        <div class="row d-flex " style="margin-left:0 !important">
            <div class="baseline_box" id="baseline_box1" @click="changeborder1(true)" @blur="changeborder1(false)">

                <!--input
          type="number"
          v-model="login.cc"
          class="input-text"
          id="inputCedula"
          aria-describedby="numberHelp"
          required
          placeholder="Cédula"
          autocomplete="off"
          @click="changeborder1(true)"
          @blur="changeborder1(false)"
        -->
                <b-form-select id="SelectCategoria" class="col-sm-12 mt-4 SelectCategoria" v-model="selectLineDeal"
                    :options="optionsLineDeals" @blur.native="changeborder1(false)" @change="getInfo"></b-form-select>

                <label class="label-helper" for="SelectCategoria">Punto de venta</label>
            </div>

            <!--button class="col-md-5 col-sm-12 regular text-left" @click="getHistory()">
            <img class="centerImg1 mr-3" src="@/assets/images/icons/eye.svg" width="20px">Ver historial de modificaciones
            </button-->

            <button pill @click="getHistory()" class="text-center small-flat col-md-5 col-sm-12" variant="light"
                style="border:none;">
                Ver historial de modificaciones<span class="icon icon-eye1 ml-2 mt-1"></span>
            </button>
        </div>

        <!-- Ninguna opción Seleccionada -->
        <div class="mt-5" v-if="loading" id="loader"></div>

        <div v-if="selectLineDeal == null && !loading" class="mt-5  row col-12">
            <!--p class="alert alert-warning col-12" role="alert">Aún no has elegido una línea de negocio</p-->
            <div class="alert alert-dark alert-sm alert-info-custom info-alert" role="alert">
                <h5><span class="icon icon-info text-primary mr-2 mt-2" style="    margin-left: 10px;
    position: relative;
    top: 2px !important;
"></span>
                    Aún no has elegido una línea de negocio
                </h5>
            </div>

            <div class="row col-12 d-flex justify-content-left">
                <img src="@/assets/images/platformSettings/undraw_Dropdown_menu_re_jqqs 1.svg" alt=""
                    class="col-5 mt-5">
            </div>
        </div>
        <p v-if="selectLineDeal !== null && !loading" class="choose">Escoge alguna de estas opciones:</p>
        <div v-if="selectLineDeal !== null && !loading" class="row pt-1 pl-4 d-flex justify-content-between ">

            <!-- Cargos/Escenarios --Bolsas de apoyo -->
            <div v-if="!loading" class="col-md-4 col-sm-12 opciones">

                <div v-for="item in itemsLineDeal" :key="item.id" class="d-flex col-12 p-0 opciones_item ">
                    <div class="item col-lg-12 col-sm-6" @click="pointsTable(item)">
                        <span class="cta-small">{{ item.type }}</span>
                        <p class="label-regular" v-if="item.name !== ''">{{ item.name }}
                        </p>
                    </div>
                    <div class=" col-lg-2 col-sm-2" @click="pointsTable(item)">

                        <img class=" mt-0 " src="../../assets/images/icons/icon_mostrar.svg"
                            style=" visibility:hidden;; width:20px; height:20px; align-text:right;" />
                    </div>
                </div>
            </div>



            <!--div v-if="loading2" class="col-7">
            <div class="mt-5 " v-if="loading2" id="loader2"></div>
        </div-->
            <div v-if="loading2" style="width:50%;
display: flex;
justify-content: center;">
                <span>
                    <img class="spinner-logo mt-4" src="../../assets/images/login/master_isotipo_VP.svg"
                        style=" width:20px; height:20px;" alt="logo" />
                    <span class="sr-only">Loading...</span>
                </span>
            </div>
            <!-- Tabla cargos -->
            <div v-if="checkCharges && !loading2" class="table-responsive col-md-7 col-sm-12 table-views">
                <div class="t-head body_bold">
                    <p>Lista de Cargos por {{ contentTableEmployees.name }}</p>
                </div>
                <!--div class="px-3 mb-5">
              <input v-model="datatable.filter" type="text" class="form-control mt-5 input-vp2" placeholder="Buscar Cargo">
              </div-->
                <div class="col-12">
                    <div class="buscar-empleado mt-4 mb-4">
                        <div class=" input-group-prepend">
                            <span class="icon icon-search1"></span>
                        </div>
                        <input type="search" placeholder="Buscar Cargo" aria-label="Buscar Cargo" autocomplete="off"
                            class="form-control body_regular " v-model="datatable.filter" style="border:0px">
                    </div>
                </div>
                <p v-if="contentTableEmployees.charges.length == 0" class="choose ml-4">No hay cargos asignados a esta
                    bolsa de apoyo</p>
                <div data-spy="scroll" class="info-container">
                    <div v-for="category in contentTableEmployees.charges" :key="category.id">
                        <b-button v-b-toggle="category.name_category"
                            class="col-12 buttonColapse d-flex align-items-center">
                            <div class="textButtonColapse col-3 d-flex align-items-center">
                                <p class="m-0 pr-2">{{ category.name_category }}</p>
                                <img class="centerImg1 arrow" style="color:blue;"
                                    src="@/assets/images/icons/arrow-drop-up-line.svg" width="15px">
                            </div>
                            <!--div class="restOfButton col-9"></div-->
                        </b-button>
                        <b-collapse visible :id="category.name_category">
                            <div v-for="charge in category.charges" :key="charge.id">
                                <div class="charge d-flex align-items-center justify-content-between"
                                    @click="openModals(charge)">
                                    <span class="tbl_header" charge-name>{{ charge.name }}</span>

                                    <button type="button" class="button-secundary" v-if="charge.points == 0">
                                        <span class="cta-mall" style="width:100%">Agregar puntaje</span>
                                        <img class="ml-2" src="@/assets/images/icons/icon-mas.svg">
                                    </button>
                                    <!--span v-if="charge.points == 0" class="icon-plus"></span-->
                                    <div v-else class="d-flex align-items-center">
                                        <p class="m-0 pr-2 points cta-small " style="color:#37474F;font-size: 16px;">
                                            Puntaje <label style="color:#7A7CFF;font-size: 16px;">{{ charge.points
                                            }}</label></p><img class="centerImg1 pb-2"
                                            src="@/assets/images/icons/edit_pencil.svg" width="15px">
                                    </div>
                                </div>
                            </div>
                        </b-collapse>
                    </div>
                </div>
            </div>

            <!-- Tabla Bolsas de apoyo -->
            <div data-spy="scroll" v-if="checkSupportBags && !loading2"
                class="table-responsive col-md-7 col-sm-12 table-views">
                <div class="t-head">
                    <p>Bolsa de apoyo - {{ supportBag2.name }}</p>
                </div>
                <div class="px-3 mb-5">
                    <input v-model="filterBolsa" type="text" class="form-control mt-5 input-vp2"
                        placeholder="Buscar bolsa de apoyo" @keyup="finishTipyngBolsa()">
                </div>
                <div data-spy="scroll" class="info-container">
                    <div v-for="item in contentTableSB" :key="item.id">
                        <div class="charge d-flex align-items-center justify-content-between" @click="openModals(item)">
                            <span class="tbl_header">{{ item.name }}</span>
                            <button type="button" class="button-secundary " v-if="item.points == 0">
                                <span class="cta-small" style="width:100%">Agregar puntaje</span>
                                <img class="ml-2" src="@/assets/images/icons/icon-mas.svg">
                            </button>
                            <!--span v-if="item.points == 0" class="icon-plus"></span-->
                            <div v-else class="d-flex align-items-center">
                                <p class="m-0 pr-2 points cta-small " style="color:#37474F;font-size: 16px;">Puntaje
                                    <label style="color:#7A7CFF;font-size: 16px;"> {{ item.points }}</label>
                                </p><img class="centerImg1 pb-2" src="@/assets/images/icons/checkbox-circle-line.svg"
                                    width="16px">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal de Inicio -->

        <b-modal id="modal-points" hide-footer centered>
            <div class="col-12 d-flex flex-column align-items-center modal-vp2">
                <h2 class="pt-2 font-weight-bold">{{ type.name }} - {{ modal.name }}</h2>
                <label class="pb-2  table-value" style="color: #455A64;">Agregar puntaje para el {{ type.name }}
                    {{ modal.name }}</label>
                <!--input v-model="modal.points" type="number" class="form-control mt-4 input-vp2" placeholder="Puntaje"-->
                <div class="baseline_box d-flex mr-0 align-items-center" id="baseline_box">
                    <input v-model="modal.points" type="number" autocomplete="off" class="input-text"
                        style="width:390px;" placeholder="Puntaje" @click="changeborder(true)"
                        @blur="changeborder(false)" />
                    <label class="label-helper" for="inputpwdCurrent">Ingresa puntaje</label>
                </div>

                <div style="width:100%;display:flex;margin-top:32px;">
                    <button @click="$bvModal.hide('modal-points'), $bvModal.show('modal-points2')" type="button"
                        class="button-primary enviar-mensaje" style="border:none;">
                        <span class="cta" style="width:100%">Confirmar</span>
                    </button>

                    <button type="button" class="button-secundary" style="margin:auto;"
                        @click="$bvModal.hide('modal-points')">
                        <span class="cta" style="width:100%">Cancelar</span>
                    </button>
                </div>

                <!--button class="regular mt-3" @click="$bvModal.hide('modal-points')">Cancelar</button>
                <button class="mt-2 mb-5 col-6 btn btn-success" @click="$bvModal.hide('modal-points'), $bvModal.show('modal-points2')">Guardar Cambios</button-->
            </div>
        </b-modal>

        <!-- Modal de Confirmación -->

        <b-modal id="modal-points2" hide-footer centered>
            <div class="col-12 d-flex flex-column align-items-center modal-vp2">
                <h2 class="pt-2 font-weight-bold">¿Estás seguro de modificar este Puntaje?</h2>
                <label class="pb-2  table-value" style="color: #455A64;">{{ type.name }} - {{ modal.name }}</label>
                <p style="font-size:16px;"><span class="font-weight-bold">Puntaje: </span>{{ modal.points }}</p>

                <div style="width:100%;display:flex;margin-top:32px;">
                    <button @click="$bvModal.hide('modal-points2'), savePoints()" type="button"
                        class="button-primary enviar-mensaje" style="border:none;">
                        <span class="cta" style="width:100%;">Guardar cambios</span>
                    </button>

                    <button type="button" class="button-secundary" style="margin:auto;"
                        @click="$bvModal.hide('modal-points2'), $bvModal.show('modal-points')">
                        <span class="cta" style="width:100%;">Volver</span>
                    </button>
                </div>

                <!--button class="mt-5 col-6 btn btn-success" @click="$bvModal.hide('modal-points2'),savePoints()">Guardar Cambios</button>
                <button class="regular mt-3 mb-5" @click="$bvModal.hide('modal-points2'),$bvModal.show('modal-points')">Volver</button-->
            </div>
        </b-modal>

        <!-- MODAL EXITOSO  -->

        <b-modal id="modal-success" hide-footer centered>
            <div class="col-12 d-flex flex-column align-items-center modal-vp2">
                <img class="centerImg1" src="@/assets/images/icons/checkbox-circle-line.svg">
                <h2 class="pt-5 font-weight-bold">¡Proceso exitoso!</h2>
                <label class="pb-2  table-value" style="color: #455A64;margin-bottom:16px;">{{ message.message
                }}</label>
                <button @click="$bvModal.hide('modal-success')" type="button" class="button-primary enviar-mensaje"
                    style="border:none;">
                    <span class="cta" style="width:100%;">Entendido</span>
                </button>
                <!--button class="mt-5 mb-5 col-6 btn btn-success" @click="$bvModal.hide('modal-success')">Entendido</button-->
            </div>
        </b-modal>

        <!-- MODAL FALLIDO -->

        <b-modal v-if="error.message" id="modal-fail" hide-footer centered>
            <div class="col-12 d-flex flex-column align-items-center modal-vp2">
                <img class="centerImg1" src="@/assets/images/icons/close.svg" width="20%">
                <h2 class="pt-5 font-weight-bold">¡Proceso fallido!</h2>
                <label class="pb-2  table-value" style="color: #455A64;margin-bottom:16px;">{{ error.message }}</label>
                <button class="mt-5 mb-5 col-6 btn btn-danger" @click="$bvModal.hide('modal-fail')">Entendido</button>
            </div>
        </b-modal>

        <!-- Modal Historial -->

        <b-modal size='xl' id="modification-history" hide-footer centered>
            <div class="col-12 d-flex flex-column align-items-center modal-vp2">
                <h2 class="font-weight-bold">
                    <img class="centerImg1 mr-3" src="@/assets/images/icons/blue-eye.svg" width="33px">Historial de
                    modificaciones realizadas
                </h2>

                <div v-if="loading2" class="col-12">
                    <div class="mt-5" v-if="loading2" id="loader2"></div>
                </div>
                <!--span  v-if="loading2" >
        <img class="spinner-logo mt-2"  src="../../assets/images/login/master_isotipo_VP.svg" style="margin:auto;width:20px; height:20px;"  alt="logo" />
        <span class="sr-only">Loading...</span>
      </span-->
                <div v-else class="px-3 table-responsive table-views">
                    <datatable :columns="datatable.columns" :data="datatable.rows" :filter="datatable.filter"
                        :per-page="datatable.perPage" :page="datatable.page"
                        class="col-12 mt-5 table table-hover table-borderless ">
                        <template slot-scope="{ row, columns }">
                            <tr @click="editEmployee(row)">
                                <template>
                                    <datatable-cell v-for="(column, j) in columns" :key="j" :column="column" :row="row">
                                    </datatable-cell>
                                </template>
                            </tr>
                        </template>
                    </datatable>
                    <div class="col-12 cont-pagination my-5 d-flex justify-content-center">
                        <Pagination :data="history" :limit="10" @pagination-change-page="getHistory"></Pagination>
                    </div>
                </div>
                <button class="button-primary enviar-mensaje"
                    @click="$bvModal.hide('modal-points'), $bvModal.hide('modification-history')"><span class="cta"
                        style="width:100%;">Entendido</span></button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Pagination from "laravel-vue-pagination";

export default {
    name: "updatePoints",
    components: { Pagination },
    data() {
        return {
            hover: false,
            arrow: true,
            type: {},
            modal: {},
            scenario: 0,
            selectLineDeal: null,
            optionsLineDeals: [{ value: null, text: 'Seleccione una Categoria' }],
            itemsLineDeal: [],
            contentTableSB: [],
            contentTableEmployees: {},
            chargesLineDeal: [],
            supportBag2: {},
            checkCharges: false,
            checkScenarios: false,
            checkSupportBags: false,
            datatable: {
                total: 18,
                perPage: 20,
                columns: [],
                rows: [],
                filter: '',
                page: 1,
            },
            filterBolsa: ''
        }
    },
    beforeMount() {
        this.getLineDeals()
    },
    computed: {
        ...mapState("modPlatformSettings", [
            "lineDeals",
            "lineDealInfo",
            "supportBags",
            "supportBag",
            "loading",
            "loading2",
            "scenarios",
            "error",
            "message",
            "history"
        ]),
    },
    methods: {
        ...mapActions("modPlatformSettings", [
            'actLineDeals',
            'actGetInfoLineDeal',
            'actGetAllSupportBags',
            'actGetInfoBySupportBag',
            'actGetChargesBySupportBag',
            'actGetInfoByScenario',
            'actSavePoints',
            'actGetModificationHistory'
        ]),

        changeborder(change) {
            if (change) {
                document.getElementById("baseline_box").style.borderColor = "#5D5FEF";

            } else {

                document.getElementById("baseline_box").style.borderColor = "#78909C";
            }
        },
        changeborder1(change) {
            if (change) {
                document.getElementById("baseline_box1").style.borderColor = "#5D5FEF";

            } else {

                document.getElementById("baseline_box1").style.borderColor = "#78909C";
            }
        },

        getHistory(page = 1) {
            let data2 = [];
            data2 = {
                'page': page,
            };
            this.$root.$emit('bv::show::modal', 'modification-history')
            this.actGetModificationHistory(data2).then(() => {
                this.datatable.columns = [
                    {
                        label: "Mánager",
                        field: "name",
                        align: "left",
                        headerClass: "theading",
                    },
                    {
                        label: "Tipo de modificación",
                        field: "modification_type",
                        align: "left",
                        headerClass: "theading",
                    },
                    {
                        label: "Origen",
                        field: "description",
                        align: "left",
                        headerClass: "theading",
                    },
                    {
                        label: "Fecha y hora",
                        field: "date",
                        align: "left",
                        headerClass: "theading",
                    }

                ];
                this.datatable.rows = []
                this.history.data.forEach(x => {
                    this.datatable.rows.push({
                        name: x.name,
                        modification_type: x.modification_type,
                        description: x.description,
                        date: x.date,
                    })
                })
            })
        },

        getLineDeals() {
            let data = {
                'page': 1,
            };
            this.actLineDeals(data).then(() => {
                var optionsLB = []
                this.lineDeals.data.data.forEach(x => {
                    optionsLB.push({
                        value: x.id,
                        text: x.name
                    })
                });
                this.optionsLineDeals.push(
                    {
                        label: 'Lineas de Negocio',
                        options: optionsLB
                    },
                    {
                        label: 'Bolsas de Apoyo',
                        options: [{ value: 'bs', text: 'Bolsas de Apoyo' }]
                    }
                )
            })
        },
        getInfo() {

            this.checkCharges = false
            this.checkScenarios = false
            this.checkSupportBags = false
            this.itemsLineDeal = []
            if (this.selectLineDeal !== null) {
                if (this.selectLineDeal == 'bs') {
                    this.actGetAllSupportBags().then(() => {
                        this.supportBags.forEach(x => {
                            this.itemsLineDeal.push({
                                type: 'Bolsa de Apoyo',
                                name: x.name,
                                id: x.id
                            })
                        })

                    })
                } else {
                    this.actGetInfoLineDeal(this.selectLineDeal).then(() => {
                        if (this.lineDealInfo.scenarios) {
                            this.lineDealInfo.scenarios_data.forEach(x => {
                                this.itemsLineDeal.push({
                                    type: 'Escenario',
                                    name: x.name,
                                    id: x.id
                                })
                            })
                        } else {
                            this.itemsLineDeal.push({
                                type: 'Cargos',
                                name: '',
                                id: ''
                            })
                        }
                        this.lineDealInfo.support_bags.forEach(x => {
                            this.itemsLineDeal.push({
                                type: 'Bolsa de Apoyo',
                                name: x.name,
                                id: x.id
                            })
                        })

                    })
                }
            }
        },
        pointsTable(x) {
            let ids = {
                'lb': this.selectLineDeal,
                'sb': x.id
            }
            this.checkCharges = false
            this.checkScenarios = false
            this.checkSupportBags = false
            this.contentTableSB = []
            this.item_actived = x.id;
            switch (x.type) {
                case 'Cargos':
                    this.type = {
                        name: 'Cargo',
                        id: 1
                    }
                    this.contentTableEmployees = {
                        name: x.name,
                        charges: this.lineDealInfo.charges,
                    }
                    this.checkCharges = true
                    break;
                case 'Bolsa de Apoyo':
                    this.supportBag2 = {
                        name: x.name,
                        id: x.id
                    }
                    if (this.selectLineDeal == 'bs') {
                        this.actGetChargesBySupportBag(x.id).then(() => {
                            this.type = {
                                name: 'Cargo',
                                id: 5
                            }
                            this.contentTableEmployees = {
                                name: x.name,
                                charges: this.supportBag.data,
                            }
                            this.checkCharges = true
                        })
                    } else {
                        this.actGetInfoBySupportBag(ids).then(() => {
                            if (!this.supportBag.points_sale) {
                                this.type = {
                                    name: 'Punto de venta',
                                    id: 4
                                }
                                this.supportBag.data_points_sale.forEach(y => {
                                    this.contentTableSB.push({
                                        name: y.name,
                                        points: y.points,
                                        id: y.id
                                    })
                                })
                            } else {
                                this.type = {
                                    name: 'Bolsa de Apoyo',
                                    id: 2
                                }
                                this.contentTableSB.push({
                                    name: x.name,
                                    points: this.supportBag.points
                                })
                            }
                            this.checkSupportBags = true

                        })
                    }

                    break;
                case 'Escenario':
                    this.type = {
                        name: 'Cargo',
                        id: 3
                    }
                    this.scenario = x.id
                    this.actGetInfoByScenario(x.id).then(() => {
                        this.contentTableEmployees = {
                            name: x.name,
                            charges: this.scenarios.charges
                        }
                        this.checkCharges = true
                    })
                    break;
                default:
            }
        },
        openModals(x) {
            this.modal = {
                name: x.name,
                points: x.points == 0 ? '' : x.points,
                id: x.id
            }
            this.$root.$emit('bv::show::modal', 'modal-points')
        },
        savePoints() {
            let data = {}
            switch (this.type.id) {
                case 1:
                    data = {
                        type: this.type.id,
                        pro_position_id: this.modal.id,
                        pro_line_deal_id: this.selectLineDeal,
                        points: this.modal.points
                    }
                    break;
                case 2:
                    data = {
                        type: this.type.id,
                        pro_support_bag_id: this.supportBag2.id,
                        pro_line_deal_id: this.selectLineDeal,
                        points: this.modal.points
                    }
                    break;
                case 3:
                    data = {
                        type: this.type.id,
                        pro_scene_id: this.scenario,
                        position_id: this.modal.id,
                        points: this.modal.points
                    }
                    break;
                case 4:
                    data = {
                        type: this.type.id,
                        pro_support_bag_id: this.supportBag2.id,
                        pro_point_sale_id: this.modal.id,
                        points: this.modal.points
                    }
                    break;
                case 5:
                    data = {
                        type: this.type.id,
                        pro_support_bag_id: this.supportBag2.id,
                        pro_position_id: this.modal.id,
                        points: this.modal.points
                    }
                    break;
            }
            this.actSavePoints(data).then(() => {
                if (this.error.message) {
                    this.$root.$emit('bv::hide::modal', 'modal-points2')
                    this.$root.$emit('bv::show::modal', 'modal-fail')
                    this.getInfo()
                    return
                } else {
                    this.$root.$emit('bv::hide::modal', 'modal-points2')
                    this.$root.$emit('bv::show::modal', 'modal-success')
                    this.getInfo()
                }
            })
        },


        finishTipyng() {
            clearTimeout(this.runTime);
            this.runTime = setTimeout(() => {
                this.getFilterDp(1)
            }, 1500);
        },

        finishTipyngBolsa() {
            clearTimeout(this.runTime);
            this.runTime = setTimeout(() => {
                this.getFilterDpBolsa()
            }, 1500);
        },

        getFilterDpBolsa() {
            if (this.datatable.filter !== '') {
                this.checkCharges = false
                //alert(this.datatable.filter);
                this.contentTableEmployees = {
                    name: this.datatable.filter,
                    charges: this.lineDealInfo.charges,
                }
                this.checkCharges = true
            }
        },


        getFilterDp() {
            if (this.datatable.filter !== '') {
                this.checkCharges = false
                //alert(this.datatable.filter);
                this.contentTableEmployees = {
                    name: this.datatable.filter,
                    charges: this.lineDealInfo.charges,
                }
                this.checkCharges = true


            }
        }


    },
}

</script>

<style lang="scss">
#updatePoints {
    .baseline_box input {
        width: 390px !important;
    }

    .baseline_box {
        position: relative;
        margin-top: 8px;
        margin-bottom: 8px;
        /* content/00 */
        background: #FFFFFF;
        /* content/01 */
        border: 1px solid #ECEFF1;
        box-sizing: border-box;
        border-radius: 8px;

        label {
            /* label */
            position: absolute;
            left: 4px;
            top: -8px;
            line-height: 1;
            font-weight: bold;
            padding: 4 6px;
            display: none;

            /* label regular */
            font-family: Ubuntu;
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 16px;
            /* identical to box height, or 133% */
            display: flex;
            align-items: center;
            /* content/02 */
            color: #CFD8DC;
            background: #ffffff;
            /* Inside auto layout */
            flex: none;
            order: 0;
            flex-grow: 0;
            margin: 0px 4px;
            padding: 0px 4px;
        }

        input {

            position: static;
            width: 412px;
            height: 28px;
            left: calc(50% - 412px/2);
            top: calc(50% - 28px/2);
            background: #ffffff;
            /* body regular */
            font-family: Ubuntu;
            font-style: normal;
            font-weight: normal;
            font-size: 16px;
            line-height: 28px;
            /* content/03 */
            color: #B0BEC5;

            margin: 8px;
            border: 0;

            &:focus,
            &:active {
                outline: 0;
                border: 0;
                appearance: none;
                -moz-appearance: none;
                -webkit-appearance: none;
                box-shadow: none;
            }

        }
    }

    .button-secundary {
        margin-top: 0px !important;
        margin-bottom: 0px !important;
    }

    .charge-name {
        /* table header */

        font-family: 'Ubuntu';
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 20px;
        /* identical to box height, or 125% */


        /* content/08 */

        color: #37474F;
    }

    .buscar-empleado {
        /* Auto layout */

        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 8px 12px;

        position: static;
        width: 428px;
        height: 44px;
        left: calc(50% - 428px/2);
        top: calc(50% - 44px/2);

        /* content/00 */

        background: #FFFFFF;
        /* content/03 */

        border: 1px solid #B0BEC5;
        box-sizing: border-box;
        border-radius: 22px;

        /* Inside auto layout */

        flex: none;
        order: 0;
        flex-grow: 1;
        margin: 0px 0px;
    }

    .buscar-empleado .form-control {
        border: 0px !important;
        font-family: Ubuntu !important;
        font-style: normal !important;
        font-weight: normal !important;
        font-size: 16px !important;
        line-height: 28px !important;

    }

    .opciones {
        box-sizing: border-box;

        /* Auto layout */

        //display: flex;
        flex-direction: column;

        padding: 4px;
        gap: 4px;

        width: 288px;
        //height:310px;

        /* content/00 */

        background: #FFFFFF;
        /* CTA/00 */

        border: 1px solid #ECECFF;
        border-radius: 8px;
    }

    .opciones_item:hover {
        width: 82%;
        margin-left: 4px;
        padding: 2px;
        gap: 4px;

        img {
            visibility: visible !important;
        }
    }

    .item {
        border-bottom: none !important;
    }

    .item:hover {

        background: none !important;
        // border-left: none !important;
        border-radius: 4px !important;
        border-left: 4px solid #5D5FEF !important;
        background: #ECECFF !important;
        height: 48px !important;
        padding-left: 6px;

        img {
            visibility: visible;
        }
    }

    .opciones_item {

        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 4px;
        gap: 4px;

        width: 230px;
        height: 48px;

        /* content/00 */

        background: #FFFFFF;
    }

    .small-flat {
        margin-top: 28px;
    }

    .SelectCategoria {
        border: none !important;

        position: static;
        //width: 412px;
        height: 28px;
        left: calc(50% - 412px/2);
        top: calc(50% - 28px/2);
        background: #ffffff;
        /* body regular */
        font-family: Ubuntu;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 28px;

        /* content/03 */
        color: #78909C;
        /* Inside auto layout */
        align-self: stretch;
        flex-grow: 1;
        //margin: 8px;
        border: 0;

        &:focus,
        &:active {
            outline: 0;
            border: 0;
            appearance: none;
            -moz-appearance: none;
            -webkit-appearance: none;
            box-shadow: none;
        }
    }

    .SelectCategoria:valid+.label-helper {
        color: #78909C;
        opacity: 1;
    }

    .SelectCategoria:focus+.label-helper,
    .SelectCategoria:active+.label-helper {
        color: #5D5FEF;
        opacity: 1;
    }

    .baseline_box {
        width: 383px !important;

    }

    .info-alert {
        padding: 0px;
        //margin-left:20px;
        margin-top: 20px;
        width: 383px;
        height: 36px;
        position: relative !important;
        background: #E6F7FF !important;
        border: 1px solid #0075FF;
        box-sizing: border-box;
        border-radius: 4px;

        span {

            width: 383px;
            height: 36px;

            /* body regular */

            font-family: 'Ubuntu';
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 28px;
            /* or 175% */


            /* content/09 */

            color: #263238;
        }
    }

    .custom-select {
        padding: 10px 10px;
        font-size: 15px;
        height: 50px;
        border-radius: 10px;
    }

    .choose {
        color: #454545;
        font-family: Open Sans;
        font-style: italic;
        font-weight: normal;
        font-size: 15px;
    }

    .item {
        cursor: pointer;
        display: flex;
        height: 90px;
        flex-direction: column;
        justify-content: center;
        padding-left: 10px;
        border-left: 4px solid white;
        border-bottom: 1px solid #E9ECEE;

        h3 {
            font-weight: 500;
            font-size: 18px;
        }

        p {
            font-size: 14px;
            font-weight: 300;
            margin: 0;
        }
    }

    .item:hover,
    .item_actived {
        background: #2698870F;
        border-left: 4px solid #1C6776;
    }

    #loader2 {
        position: absolute;
        z-index: 1;
        top: 30%;
        right: 40%;
        width: 100px;
        height: 100px;
        margin: 20px;
        border: 15px solid #f3f3f3;
        border-radius: 50%;
        border-top: 15px solid #8f8f8f;
        -webkit-animation: spin 2s linear infinite;
        animation: spin 2s linear infinite;
    }

    .regular {
        background-color: white;
        border: none;
        color: #269887;
    }

    .info-container {
        height: 450px;
    }

    .table-views {
        box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);
        border-radius: 8px;
        padding: 0;
        margin: 10px 5px;

        .t-head {
            background-color: #F5F5F5;
            padding: 5px 15px;
            text-align: left;
        }

        input {
            padding: 10px 10px;
            font-size: 15px;
            height: 40px;
            border-radius: 10px;
        }

        input:focus,
        input:hover {
            //Eliminar sombra en focus.
            box-shadow: 0px 0px 0px rgba(0, 0, 0, 0);
            -webkit-box-shadow: 0px 0px 0px rgba(0, 0, 0, 0);
            -moz-box-shadow: 0px 0px 0px rgba(0, 0, 0, 0);
            border: none;
        }

        thead tr {
            background-color: #EEF2FA;
            border-radius: 10px;
            text-align: left;
        }

        .theading {
            padding: 15px 15px;
        }

        tbody tr {
            border-radius: 10px;
        }

        tbody tr td {
            padding: 15px 15px;
            cursor: pointer;
        }

        tbody tr:hover {
            background-color: #F5F5F5;
        }

        .buttonColapse,
        .buttonColapse:hover,
        .buttonColapse:active {
            background-color: transparent;
            border: none;
            box-shadow: none;
        }

        .textButtonColapse {
            //background-color: #1C6776;
            border: none;
            padding: 4px 10px;
            font-size: 11px;
            height: 25px;
            border-radius: 10px;
            margin: 5px 0;
            font-family: 'Ubuntu';
            font-style: normal;
            font-weight: 700;
            font-size: 12px;
            line-height: 16px;
            /* identical to box height, or 133% */

            display: flex;
            align-items: center;

            /* CTA/02 */

            color: #7A7CFF;
        }

        .restOfButton {
            height: 1px;
            background-color: #1C6776;
        }

        .charge {
            padding: 15px 15px;
            cursor: pointer;
        }

        .charge:hover {
            background-color: #F5F5F5;
        }

        .icon-plus {
            color: #269887;
        }

        .points {
            color: #269887;
            font-weight: 500;
            font-size: 20px;
        }

        .arrow {
            transition: 0.3s;
        }

        .collapsed .arrow {
            transition: 0.3s;
            transform: rotate(180deg)
        }

    }

    @media only screen and (max-width: 600px) {
        .item{
        justify-content: center;
        padding-left: 10px;
        border-left: 4px solid white;
        border-bottom: 1px solid #E9ECEE;
    }
        //.item:hover{
            //revisar 
           // background: #2698870F;
           //@warn border-left: 4px solid #1C6776;
        //}
    }
}

.modal-content .modal-vp2 {
    .modal-header {
        border: none;
    }

    .input-vp2,
    button {
        padding: 10px 10px;
        font-size: 15px;
        height: 40px;
        border-radius: 10px;

    }

    .btn-outline-success {
        border-radius: 20px;
        color: #269887;
        border-color: #269887;
    }

    .btn-outline-success:hover,
    .btn-success {
        color: white;
        background-color: #269887;
        border-color: #269887;
    }

    .btn-success:hover {
        background-color: #27a391;
    }

    .regular {
        background-color: white;
        border: none;
        color: #269887;
    }

    .delete {
        background-color: white;
        border: none;
        color: #DA1414;
    }

    h3 {
        font-weight: 500;
        font-size: 20px;
        line-height: 30px;
        text-align: center;
    }

    #loader2 {
        margin: 20px auto;
        z-index: 1;
        width: 100px;
        height: 100px;
        border: 15px solid #f3f3f3;
        border-radius: 50%;
        border-top: 15px solid #8f8f8f;
        -webkit-animation: spin 2s linear infinite;
        animation: spin 2s linear infinite;
    }

    .table-views {
        height: 400px;
        border-radius: 8px;
        padding: 0;

        .t-head {
            background-color: #F5F5F5;
            padding: 5px 15px;
            text-align: left;
        }

        thead tr {
            background-color: #EEF2FA;
            border-radius: 10px;
            font-size: 14px;
        }

        .theading {
            padding: 15px 15px;
        }

        tbody tr {
            border-radius: 10px;
            border-bottom: 1px solid #E9ECEE;
        }

        tbody tr td {
            padding: 15px 15px;
            font-size: 13px;
        }

        .buttonColapse,
        .buttonColapse:hover,
        .buttonColapse:active {
            background-color: transparent;
            border: none;
            box-shadow: none;
        }


    }
}
</style>